import { trpc } from "@blis/trpc/react";

import { Tab, TabPanel, Tabs, TabsList } from "@/components/ui/tabs";
import { OrganismsTable } from "../components/results/OrganismsTable";
import { ResultsTable } from "../components/results/ResultsTable";
import { Section } from "../components/Section";
import { useTabSearch } from "../hooks";

export function ResultsPage() {
  const tabsProps = useTabSearch("results");
  const { data: resultsData } = trpc.admin.testResult.list.useQuery({
    category: "TEXT",
  });
  const { data: organismsData } = trpc.admin.testResult.list.useQuery({
    category: "ORGANISM",
  });

  return (
    <>
      <Section.Title>Results</Section.Title>
      <Tabs {...tabsProps} className="flex-1 flex flex-col">
        <TabsList className="mb-4 w-full justify-start">
          <Tab id="results">Results</Tab>
          <Tab id="organisms">Organisms</Tab>
        </TabsList>
        <TabPanel id="results" className="flex flex-col flex-1">
          <ResultsTable results={resultsData} />
        </TabPanel>
        <TabPanel id="organisms" className="flex flex-col flex-1">
          <OrganismsTable organisms={organismsData} />
        </TabPanel>
      </Tabs>
    </>
  );
}
